import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { Container, Row, Col, Card } from "react-bootstrap";
//import { Link } from 'react-router-dom';

//import logo from "../../Assets/Images/controlium_logo_purple.png"
import logoWithGoogle from "../../Assets/Images/Login_with_Google.png"

const Login = () => {
    const { loginWithRedirect } = useAuth0();
    const handleLogin = async () => {
        await loginWithRedirect({
            connection:"google-oauth2",
            // prompt: "login",
            // appState: {
            //     returnTo: "/redirect",
            // },
        });
    };
    return (
        <>
        <div className="account-pages my-5">
            <Container>
            <Row className="justify-content-center">
                <Col xl={12}>
                <Card>
                    <Card.Body className="p-0">
                    <Row className="g-0">
                        <Col lg={12} className="p-4">
                            
                            <div className="auth-logo mx-auto">
                                {/* <Link to="/" className="logo logo-dark text-center">
                                    <span className="logo-lg">
                                    <img src={logo} alt="" height="24" />
                                    </span>
                                </Link>

                                <Link to="/" className="logo logo-light text-center">
                                    <span className="logo-lg">
                                    <img src={logo} alt="" height="24" />
                                    </span>
                                </Link> */}
                            </div>
                            <h6 className="h5 mb-0 mt-3">Welcome!</h6>
                            <p className="text-muted mt-1 mb-4">
                                Please sign in with your Google account to access.
                            </p> 

                            <div className="py-3 text-center">
                                <span className="fs-16 fw-bold" onClick={handleLogin} style={{cursor:'pointer'}} >
                                    <img src={logoWithGoogle} alt="" height="50"   />
                                </span>
                            </div>

                        </Col> 
                    </Row>
                    </Card.Body>
                </Card>
                </Col>
            </Row>
            </Container>
        </div>
        </>
    );
};
export default Login;